import burrata from "../../../assets/admin/landing/dishes/burrata.webp";
import kroket from "../../../assets/admin/landing/dishes/kroket.webp";
import mosselen from "../../../assets/admin/landing/dishes/mosselen.webp";
import mousse from "../../../assets/admin/landing/dishes/mousse.webp";
import steak from "../../../assets/admin/landing/dishes/steak.webp";
import stoof from "../../../assets/admin/landing/dishes/stoof.webp";
import zalm from "../../../assets/admin/landing/dishes/zalm.webp";
// Kleine versies voor de miniaturen van 56px (hero, demo, winkelmandje)
import burrataThumb from "../../../assets/admin/landing/dishes/thumbs/burrata.webp";
import kroketThumb from "../../../assets/admin/landing/dishes/thumbs/kroket.webp";
import mosselenThumb from "../../../assets/admin/landing/dishes/thumbs/mosselen.webp";
import mousseThumb from "../../../assets/admin/landing/dishes/thumbs/mousse.webp";
import steakThumb from "../../../assets/admin/landing/dishes/thumbs/steak.webp";
import stoofThumb from "../../../assets/admin/landing/dishes/thumbs/stoof.webp";
import zalmThumb from "../../../assets/admin/landing/dishes/thumbs/zalm.webp";

// Inhoud van de landingspagina. "Brasserie Het Pleintje" is een fictieve voorbeeldzaak.
// Foto's van gerechten: Unsplash (vrije licentie).

export const SHOP = {
   name: "Brasserie Het Pleintje",
   short: "Het Pleintje",
   initial: "P",
   slug: "hetpleintje",
   tagline: "Vlaamse klassiekers · Gent",
   address: "Kouter 12, Gent",
   postcode: "9000",
};

export const BUSINESS_TYPES = ["brasserie", "restaurant", "traiteur", "bistro", "pizzeria", "sushibar"];

export const CATEGORIES = [
   { id: "voor", name: "Voorgerechten" },
   { id: "hoofd", name: "Hoofdgerechten" },
   { id: "dessert", name: "Desserts" },
];

export const DISHES = [
   { id: "kroket", cat: "voor", img: kroket, thumb: kroketThumb, name: "Garnaalkroketten", desc: "Twee stuks, citroen en gefrituurde peterselie", price: 16 },
   { id: "burrata", cat: "voor", img: burrata, thumb: burrataThumb, name: "Burrata", desc: "Tomaat, basilicum en olijfolie", price: 14.5 },
   { id: "stoof", cat: "hoofd", img: stoof, thumb: stoofThumb, name: "Stoofvlees", desc: "Op grootmoeders wijze, met donker abdijbier en frietjes", price: 22.5 },
   { id: "steak", cat: "hoofd", img: steak, thumb: steakThumb, name: "Steak-frites", desc: "Béarnaise of pepersaus, verse frietjes", price: 27 },
   { id: "mosselen", cat: "hoofd", img: mosselen, thumb: mosselenThumb, name: "Mosselen natuur", desc: "Zeeuwse mosselen, frietjes en huismayonaise", price: 29 },
   { id: "zalm", cat: "hoofd", img: zalm, thumb: zalmThumb, name: "Gebakken zalm", desc: "Groene asperges en beurre blanc", price: 25 },
   { id: "mousse", cat: "dessert", img: mousse, thumb: mousseThumb, name: "Chocolademousse", desc: "Pure chocolade, slagroom en framboos", price: 8.5 },
];

export const dish = (id) => DISHES.find((d) => d.id === id);

/* ---------------- Vooraf bestellen: dagen en momenten ---------------- */

const WEEKDAYS = ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
const MONTHS = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];

// De komende dagen vanaf vandaag: { label: "Zaterdag", short: "za", long: "zaterdag", date: "11 okt" }
export function upcomingDays(count = 4, from = new Date()) {
   return Array.from({ length: count }, (_, i) => {
      const d = new Date(from);
      d.setDate(d.getDate() + i);
      const wd = WEEKDAYS[d.getDay()];
      const long = i === 0 ? "vandaag" : i === 1 ? "morgen" : wd;
      return {
         i,
         label: long.charAt(0).toUpperCase() + long.slice(1),
         long,
         short: i < 2 ? long : wd.slice(0, 2),
         date: `${d.getDate()} ${MONTHS[d.getMonth()]}`,
      };
   });
}

export const weekdayNow = () => WEEKDAYS[new Date().getDay()].slice(0, 2);

// Afhaalmomenten per half uur, zoals de echte shop ze uit je afhaaluren haalt
export const SLOT_TIMES = ["17:30", "18:00", "18:30", "19:00", "19:30"];

export const DELIVERY_COST = 3.5;

export const FAQ = [
   {
      q: "Hoe snel sta ik online?",
      a: "Maak een account aan, zet je gerechten en foto's erin en kies je huisstijl. De meeste zaken staan dezelfde namiddag nog online, klaar voor de eerste bestelling.",
   },
   {
      q: "Nemen jullie commissie op mijn bestellingen?",
      a: "Nee. Je betaalt een vast bedrag per maand. Wat je gasten betalen, komt via Stripe op je eigen rekening. Enkel de gewone transactiekost van de betaalprovider is van toepassing.",
   },
   {
      q: "Kan ik de webshop aanpassen aan mijn zaak?",
      a: "Ja. Je kiest een thema, je logo, je foto's en de indeling van je menu. In het thema 'Klassiek kader' komen ook je eigen merkkleuren terug.",
   },
   {
      q: "Hoe werken afhalen en levering?",
      a: "Gasten kiezen vooraf een dag en een moment, voor vandaag of later in de week. Jij bepaalt je afhaaluren en hoe lang op voorhand ze moeten bestellen, zodat je altijd voorbereidingstijd hebt. Wil je leveren, dan stel je per postcode een zone in met een eigen prijs.",
   },
   {
      q: "Zijn online reservaties inbegrepen?",
      a: "Reservaties zitten in het Pro-plan. Gasten boeken zelf een tafel en je capaciteit wordt automatisch bewaakt. Cadeaubonnen voeg je bij elk plan toe als add-on.",
   },
   {
      q: "Wat als ik hulp nodig heb?",
      a: "We helpen je persoonlijk via mail of WhatsApp, ook bij het opzetten van je menu. Meestal antwoorden we binnen het uur.",
   },
];

export const COURSES = [
   {
      id: "webshop",
      course: "Amuse-bouche",
      title: "Je eigen webshop",
      body: "Je menu, je foto's, je stijl. Op je eigen adres, klaar om te delen op Instagram, je site of je visitekaartje.",
   },
   {
      id: "slots",
      course: "Voorgerecht",
      title: "Afhaalmomenten",
      body: "Gasten kiezen zelf een dag en een uur, ook dagen op voorhand. Jij legt je afhaaluren vast en hoeveel voorbereidingstijd je nodig hebt. Zo zie je ruim op tijd wat er klaar moet.",
   },
   {
      id: "delivery",
      course: "Soep",
      title: "Levering per postcode",
      body: "Stel zones in per postcode, elk met een eigen prijs. Of hou het gewoon bij afhalen, dat kies jij.",
   },
   {
      id: "payments",
      course: "Hoofdgerecht",
      title: "Online betalen",
      body: "Bancontact en kaart via Stripe. Het geld komt op je eigen rekening, en wij nemen geen commissie.",
   },
   {
      id: "discounts",
      course: "Tussengerecht",
      title: "Kortingen & collecties",
      body: "Een weekmenu, een feestcollectie of −10% op vrijdag. Snel ingesteld en meteen zichtbaar in je shop.",
   },
   {
      id: "giftcards",
      course: "Dessert",
      title: "Cadeaubonnen",
      badge: "Add-on",
      body: "Verkoop digitale bonnen die je gasten meteen kunnen weggeven. Extra omzet, vooral rond de feestdagen.",
   },
   {
      id: "reservations",
      course: "Digestief",
      title: "Reservaties",
      badge: "Pro",
      body: "Gasten boeken zelf een tafel, jij houdt je capaciteit in de hand. Sluitingsdagen en speciale openingsuren stel je één keer in.",
   },
   {
      id: "dashboard",
      course: "Koffie",
      title: "Dashboard & meldingen",
      body: "Een melding op je gsm bij elke bestelling. Omzet, bestellingen en reservaties in één helder overzicht.",
   },
];

export const STEPS = [
   {
      k: "01",
      time: "± 10 min",
      title: "Maak je account",
      body: "Kies je plan, vul je zaakgegevens in en koppel je Stripe-account om betalingen te ontvangen.",
   },
   {
      k: "02",
      time: "± 1 uur",
      title: "Zet je menu erin",
      body: "Gerechten, foto's, prijzen en opties. Kies je thema en je afhaalmomenten.",
   },
   {
      k: "03",
      time: "Service!",
      title: "Deel je link",
      body: "Zet hem op je site, Instagram of Google-profiel. De eerste bestelling komt meteen op je gsm binnen.",
   },
];
